import React, { useContext } from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { getLinkPropsFromReference } from '../../utils/link'
import { RichLinks, RichContent } from '../../utils/html'

import { getTheme } from '../../theme/theme'

import PageMetaContext from '../../context/page-meta-context';

import SectionContainer from '../section-container'

import { Heading, Inner, Content, Buttons } from './action.styles'

const Action = ({heading,links,color,overlap,overlapSmall,count}) => {
	const meta = useContext(PageMetaContext);
	return (
		<ThemeProvider theme={(theme) => ({...theme,...getTheme(color)})}>
			<SectionContainer overlap={overlap} overlapSmall={overlapSmall}>
				<Inner>
					<Content>
						{heading && <Heading>
							<RichContent render={heading} count={count} />
						</Heading>}
						{links && <Buttons>
							<RichLinks render={links} block="action" meta={meta} />
						</Buttons>}
					</Content>
				</Inner>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default Action;